import { AppStartListening } from "@/data/listenerMiddleware";
import {
  examEndDatePassed,
  examLateSubmissionDatePassed,
  examStartDatePassed,
  finalDatePassed,
  nextReleaseDatePassed,
  readingDatePassed,
  writingDatePassed,
} from "@/features/timeline";
import { refetchAssessment } from "@/graphql/api";

import { createDateListener } from "./create-date-listener";

export function startTimelineDateListeners(startListening: AppStartListening) {
  // Notify when the exam start date passes
  createDateListener(
    (state) => state.timeline.examStartDate,
    (listenerAPI) => listenerAPI.dispatch(examStartDatePassed())
  )(startListening);

  // Notify when reading date passes
  createDateListener(
    (state) => state.timeline.readingDate,
    (listenerAPI) => listenerAPI.dispatch(readingDatePassed())
  )(startListening);

  // Notify when the exam end date passes
  createDateListener(
    (state) => state.timeline.examEndDate,
    (listenerAPI) => listenerAPI.dispatch(examEndDatePassed())
  )(startListening);

  // Notify when writing date passes
  createDateListener(
    (state) => state.timeline.writingDate,
    (listenerAPI) => listenerAPI.dispatch(writingDatePassed())
  )(startListening);

  // Notify when the final due date passes
  createDateListener(
    (state) => state.timeline.finalDate,
    (listenerAPI) => listenerAPI.dispatch(finalDatePassed())
  )(startListening);

  // Notify when the exam's late submission allowed date passes
  createDateListener(
    (state) => state.timeline.examLateSubmissionDate,
    (listenerAPI) => listenerAPI.dispatch(examLateSubmissionDatePassed())
  )(startListening);

  // Notify when the next sheet release date passes and refetch the Sheet at the
  // same time.
  createDateListener(
    (state) => state.timeline.nextReleaseDate,
    (listenerAPI) => {
      listenerAPI.dispatch(nextReleaseDatePassed());
      const workId = listenerAPI.getState().authority.workId;
      if (workId) {
        refetchAssessment();
      }
    }
  )(startListening);
}
